export default __webpack_public_path__ + "static/media/Banner - Artisan - Red.4213e16b.jpg";